"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipArrow = exports.tooltip = void 0;
const tailwind_variants_1 = require("tailwind-variants");
exports.tooltip = (0, tailwind_variants_1.tv)({
  base: `
    absolute z-50 flex items-center gap-sm rounded-sm bg-tertiary p-sm
    font-primary text-sm text-inverse shadow-lg
  `,
  variants: {
    placement: {
      top: `mb-sm`,
      bottom: `mt-sm`,
      left: `mr-sm`,
      right: `ml-sm`,
      'top-start': `mb-sm`,
      'top-end': `mb-sm`,
      'bottom-start': `mt-sm`,
      'bottom-end': `mt-sm`,
      'left-start': `mr-sm`,
      'left-end': `mr-sm`,
      'right-start': `ml-sm`,
      'right-end': `ml-sm`
    }
  },
  defaultVariants: {
    placement: 'top'
  }
});
exports.tooltipArrow = (0, tailwind_variants_1.tv)({
  base: `absolute z-50 size-sm rotate-45 bg-tertiary`,
  variants: {
    placement: {
      top: `
        bottom-none left-1/2 -translate-x-1/2 translate-y-1/2 rounded-br-[3px]
      `,
      // top-rounded
      bottom: `
        left-1/2 top-none -translate-x-1/2 -translate-y-1/2 rounded-tl-[3px]
      `,
      // bottom-rounded
      left: `
        right-none top-1/2 -translate-y-1/2 translate-x-1/2 rounded-tr-[3px]
      `,
      // left-rounded
      right: `
        left-none top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-bl-[3px]
      `,
      // right-rounded
      'top-start': `bottom-none left-md translate-y-1/2 rounded-br-[3px]`,
      'top-end': `bottom-none right-md translate-y-1/2 rounded-br-[3px]`,
      'bottom-start': `left-md top-none -translate-y-1/2 rounded-tl-[3px]`,
      'bottom-end': `right-md top-none -translate-y-1/2 rounded-tl-[3px]`,
      'left-start': `right-none top-md translate-x-1/2 rounded-tr-[3px]`,
      'left-end': `bottom-md right-none translate-x-1/2 rounded-tr-[3px]`,
      'right-start': `left-none top-md -translate-x-1/2 rounded-bl-[3px]`,
      'right-end': `bottom-md left-none -translate-x-1/2 rounded-bl-[3px]`
    }
  },
  defaultVariants: {
    placement: 'top'
  }
});
